"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"
import { MemberCheckResponse } from "./fetchClientMemberCheck"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type SignUpResponse = {
  accessToken: string
  refreshToken: string
  member: {
    id: string
    profile: MemberCheckResponse
    termsAgreedAt: string
    createdAt: string
    updatedAt: string
  }
}

const fetchClientSignUp = ({
  dgtId,
  xEncParam,
  xEncTime,
}: {
  dgtId?: string
  xEncParam?: string
  xEncTime?: string
}) => {
  return fetchInterceptorInClient(
    {
      method: "post",
      headers: {
        ...(xEncParam &&
          xEncTime && {
            "x-enc-param": xEncParam,
            "x-enc-time": xEncTime,
          }),
        ...(dgtId !== undefined && { "x-enc-dgt-id": dgtId }),
      },
    },
    ROOT,
  )(() => `/api/account/sign-up`)
    .then(resultPostprocessing2<SignUpResponse>)
}

export default fetchClientSignUp
